<template>
  <div class="goodslist">
    <p class="title">兑换记录</p>
    <ul class="goods">
      <li class="item" v-for="item in goodslist" :key="item.buyId">
        <div class="img">
          <img :src="item.picture">
        </div>
        <div class="msg">
          <p class="msgtitle">{{item.goods}}</p>
          <span :class="{status:true}">{{handleStatus(item)}}</span>
          <p class="time">{{item.ctime}}</p>
        </div>
        <button
          class="btn"
          v-if="withoutGet(item)"
          @click="$emit('changeInfo',item)"
        >{{btn}}</button>
      </li>
    </ul>
    <div class="cancle" @click="handleclose"></div>
  </div>
</template>

<script>
import {my_goods} from '../utils/config'
export default {
  created() {
    this.$axios({
      method: "get",
      withCredentials: true,
      crossDomain: true,
      url:my_goods
    }).then(res => {
      let { data } = res.data;
      if (data) {
        data.sort((a, b) => {
          return new Date(b.ctime).getTime() - new Date(a.ctime).getTime();
        });
        this.goodslist = data;
      }
    });
  },
  data: () => ({
    goodslist: []
  }),
  methods: {
    handleclose() {
      this.$emit("cancle", { type: "goodslist" });
    },
    handleStatus(item) {
      let { status, address, type } = item;
      if (status == 0) {
        return "未领取";
      } else {
        if (
          (type == "SW" && address == "") ||
          (type == "QB" && address == "")
        ) {
          return "未领取";
        } else if (type == "LB" || type == "POINTS") {
          return "已领取";
        } else {
          return address;
        }
      }
    },
    withoutGet(item) {
      let { status, type } = item;
      if(status === 0 && (type === 'points' || type === 'HB' || type === 'lb' || type==='fd')){
        this.btn='重新领取'
        return true;
      }
      if(status==0){
        this.btn='修改信息'
        return true
      }else if(type == 'HB'){
        return false
      }
      this.btn='修改信息'
      return true
    }
  }
};
</script>

<style lang="scss" scoped>
.goodslist {
  padding: 40px 35px 35px 35px;
  background: #fff;
  border-radius: 15px;
  max-height: 1120px;
  width: 940px;
  box-sizing: border-box;
  overflow: hidden;
  .title {
    font-size: 40px;
    margin: 0;
    text-align: center;
  }
  .goods {
    height: 950px;
    margin-top: 60px;
    overflow-y: scroll;
    padding: 20px;
    .item {
      width: 840px;
      height: 180px;
      border-radius: 8px;
      box-shadow: 0 0 10px #e1e1f5;
      margin-bottom: 20px;
      position: relative;
      .btn {
        position: absolute;
        right: 40px;
        top: 50%;
        transform: translateY(-50%);
        width: 200px;
        border-radius: 34px;
        font-size: 26px;
        line-height: 68px;
        text-align: center;
        color: #000;
        background: #f5c61e;
      }
      .img {
        width: 180px;
        height: 100%;
        float: left;
        padding: 30px 30px;
        box-sizing: border-box;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .yellow {
        color: #f58d44;
      }
      .msg {
        float: left;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
        padding: 30px 0;
        box-sizing: border-box;
        .msgtitle {
          font-size: 34px;
          font-weight: 600;
        }
        .status {
          display: block;
          font-size: 32px;
          width: 400px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .time {
          font-size: 28px;
          color: #8e8e8e;
        }
      }
    }
  }
  .cancle {
    position: absolute;
    bottom: -132px;
    left: 50%;
    transform: translateX(-50%);
    width: 50px;
    height: 50px;
    background: url("../assets/guanbi.png") no-repeat;
    background-size: 100% 100%;
  }
}
</style>
